<script lang="ts">
	import { twMerge } from 'tailwind-merge';
	let className = '';
	export { className as class };
</script>

<svg
	xmlns="http://www.w3.org/2000/svg"
	viewBox="0 0 112.044 112.044"
	class={twMerge('', className)}
>
	<defs>
		<clipPath id="tqayjyn1pa">
			<path data-name="Rechteck 1069" style="fill:none" d="M0 0h112.044v112.044H0z" />
		</clipPath>
	</defs>
	<g data-name="Gruppe 1102" style="clip-path:url(#tqayjyn1pa)">
		<path
			data-name="Pfad 731"
			d="M36.643 0 0 36.534v41.825a33.685 33.685 0 0 0 33.684 33.685h78.36V0zm65.642 102.285h-68.6A23.953 23.953 0 0 1 9.759 78.359V41.631h31.358V9.759h61.168z"
			style="fill:#d6f036"
		/>
	</g>
</svg>
